import { CustomErrorPage } from '~/components/common/CustomErrorPage'
import Router from 'next/router'
import { useEffect } from 'react'

export default function Custom404() {
  useUpdateIsReady()

  const errorDetail = [
    'アクセスしようとしたページは削除、変更されたか、現在利用できない可能性があります。',
    'お手数をおかけしますが、toridori marketingのホームに戻っていただきますようお願いいたします。',
  ]

  return <CustomErrorPage errorTitle="お探しのページが見つかりませんでした" errorDetail={errorDetail} type={404} />
}

// 404ページから読み込んだ場合にrouter.isReadyがfalseのまま変わらないので書き換える
// https://app.asana.com/0/0/1200406758336053/1200402690026111/f
const useUpdateIsReady = () => {
  useEffect(() => {
    if (!Router.router) throw new Error('No router instance found')
    Router.router.isReady = true
  }, [])
}
